// extracted by mini-css-extract-plugin
export var headline = "map-headline-module--headline--3_4ME";